import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import { ControlLabel, DropdownButton, FormGroup, MenuItem } from 'react-bootstrap';
import { find, map } from 'lodash/collection';

class SingleSelectButton extends Component {
  constructor(props) {
    super(props);
    this.handleSelect = this.handleSelect.bind(this);
    this.state = {
      selectedItem: this.props.activeItem
    };
  }

  handleSelect(clickedItem) {
    this.setState({ selectedItem: clickedItem });
    this.props.onSelect(this.props.id, clickedItem);
  }

  render() {
    const { id, label, className, items, disabled } = this.props;

    const menuItems = map(items, item => (
      <MenuItem
        key={item.id}
        eventKey={item.id}
        active={item.id === this.props.activeItem}
      >
        {item.name}
      </MenuItem>
    ));

    // const activeItem = find(items, item => (item.id === this.state.selectedItem));
    const activeItem = find(items, item => (item.id === this.props.activeItem));
    const dropDownButton = (
      <DropdownButton
        className="single-select-button"
        id={id}
        title={activeItem ? activeItem.name : ''}
        onSelect={(eventKey) => { this.handleSelect(eventKey) }}
        disabled={disabled}
      >
        {menuItems}
      </DropdownButton>
    );

    return label ? (
      <FormGroup className={`filter-single-select ${className}`}>
        <ControlLabel htmlFor={id}>{label}</ControlLabel>
        {dropDownButton}
      </FormGroup>
    ) : dropDownButton;
  }
}

SingleSelectButton.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  className: PropTypes.string,
  items: PropTypes.array.isRequired,
  activeItem: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  onSelect: PropTypes.func.isRequired,
  disabled: PropTypes.bool
};

SingleSelectButton.defaultProps = {
  label: '',
  className: '',
  disabled: false
};

export default translate(['common'], { wait: true })(SingleSelectButton);



// WEBPACK FOOTER //
// ./src/components/SingleSelectButton/index.jsx